// contexts/produtos/VariacaoItemContext.js
import React, { createContext, useContext, useState } from 'react';
import { fetchData, postData, putData, deleteData } from '../../services/Api';
import { useAlert } from '../geral/AlertContext';
import { useMessage } from '../geral/MessageContext';

const VariacaoItemContext = createContext();

export const useVariacaoItem = () => useContext(VariacaoItemContext);

export const VariacaoItemProvider = ({ children }) => {
    const [variacaoItens, setVariacaoItens] = useState([]);
    const { showAlert } = useAlert();
    const { showMessage } = useMessage();

    const fetchVariacaoItens = async (variacaoId) => {
        try {
            if (!variacaoId) {
                setVariacaoItens([]);
                return [];
            }

            const result = await fetchData('/VariacaoItem', { variacaoId });
            setVariacaoItens(result);
            return result;
        } catch (error) {
            console.error('Erro ao buscar itens da variacao:', error);
            showMessage(`Erro ao buscar itens da variacao!\n${error}`, 'danger');
            return [];
        }
    };

    const addVariacaoItem = async (item, options = {}) => {
        try {
            const result = await postData('/VariacaoItem', item);
            setVariacaoItens((current) => [...current, result]);
            if (!options.silent) showAlert('Item de variacao adicionado com sucesso!');
            return result;
        } catch (error) {
            console.error('Erro ao adicionar item de variacao:', error);
            showMessage(`Erro ao adicionar item de variacao!\n${error}`, 'danger');
            return null;
        }
    };

    const updateVariacaoItem = async (item, options = {}) => {
        try {
            const result = await putData('/VariacaoItem', item);
            setVariacaoItens((current) => current.map((i) => (i.id === result.id ? result : i)));
            if (!options.silent) showAlert('Item de variacao alterado com sucesso!');
            return result;
        } catch (error) {
            console.error('Erro ao atualizar item de variacao:', error);
            showMessage(`Erro ao atualizar item de variacao!\n${error}`, 'danger');
            return null;
        }
    };

    const deleteVariacaoItem = async (id, options = {}) => {
        try {
            await deleteData('/VariacaoItem', { id });
            setVariacaoItens((current) => current.filter((i) => i.id !== id));
            if (!options.silent) showAlert('Item de variacao excluido com sucesso!');
            return true;
        } catch (error) {
            console.error('Erro ao excluir item de variacao:', error);
            showMessage(`Erro ao excluir item de variacao!\n${error}`, 'danger');
            return false;
        }
    };

    return (
        <VariacaoItemContext.Provider
            value={{ variacaoItens, fetchVariacaoItens, addVariacaoItem, updateVariacaoItem, deleteVariacaoItem }}
        >
            {children}
        </VariacaoItemContext.Provider>
    );
};
